// src/hooks/useCompactLayout.js
//
// True on tablets and phones. The desktop shell is a fixed 1536px canvas scaled to the
// window; on small screens it would be scaled down to unreadable sizes, so the shell (and
// pages that have one) switch to a flowing layout:
//   * any window narrower than COMPACT_MAX (phones in portrait and landscape, tablets in
//     portrait, small browser windows);
//   * a touch-first device (primary pointer is a finger) up to TOUCH_COMPACT_MAX wide —
//     tablets in landscape (iPad 1024 / 1180, iPad Pro 1366), which would otherwise get
//     the desktop canvas shrunk to ~2/3. Laptops and desktops (mouse / trackpad) keep the
//     desktop layout at any width from COMPACT_MAX up.
import { useEffect, useState } from 'react';

export const COMPACT_MAX = 1024;
export const TOUCH_COMPACT_MAX = 1400;

const isCompact = () => {
  if (typeof window === 'undefined') return false;
  const w = window.innerWidth;
  if (w < COMPACT_MAX) return true;
  const touchFirst = !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches);
  return touchFirst && w < TOUCH_COMPACT_MAX;
};

export default function useCompactLayout() {
  const [compact, setCompact] = useState(isCompact);
  useEffect(() => {
    const onChange = () => setCompact(isCompact());
    window.addEventListener('resize', onChange);
    window.addEventListener('orientationchange', onChange);
    return () => {
      window.removeEventListener('resize', onChange);
      window.removeEventListener('orientationchange', onChange);
    };
  }, []);
  return compact;
}
